import { RfxSupplierPaths, BaseMemberPaths } from "./navigation.types";

export class SupplierPaths extends BaseMemberPaths {
	shareProfile: string;

	rfx: RfxSupplierPaths;

	constructor(companyId: number) {
		super(companyId);

		this.shareProfile = this.prefixWithBasePath("profile/share");

		this.home = this.companyProfile.information;

		this.rfx = {
			all: this.prefixWithBasePath("rfx"),
			accepted: this.prefixWithBasePath("rfx/accepted"),
			awarded: this.prefixWithBasePath("rfx/awarded"),
			submitted: this.prefixWithBasePath("rfx/submitted"),
			unsuccessful: this.prefixWithBasePath("rfx/unsuccessful"),
		};
	}
}
